var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import qs from 'query-string';
import { trackEvent } from '@raisin/events-tracking';
import { LOGIN_CLIENT_ID } from '../constants';
import { Service } from '../enums/service';
import { createLogOutSucceededEvent } from '../eventsTracking';
import { getMicroServiceBaseUrl, getRefreshToken, hasCookieForSession, isCSR, isLocalEnv, } from '../utils';
export const OBS_API_BASE_URL = isCSR()
    ? `${window.location.origin}/savingglobal/rest/open_api/v2`
    : '';
export const logout = () => __awaiter(void 0, void 0, void 0, function* () {
    yield axios.post(`${OBS_API_BASE_URL}/logout`);
});
export const keycloakLogout = (refreshToken) => __awaiter(void 0, void 0, void 0, function* () {
    const data = qs.stringify({ refresh_token: refreshToken, client_id: LOGIN_CLIENT_ID });
    return axios.post(`${getMicroServiceBaseUrl(Service.KEYCLOAK)}/protocol/openid-connect/logout`, data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
});
export const refreshJSessionId = ({ userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (isLocalEnv())
        return;
    try {
        yield axios.get(`${OBS_API_BASE_URL}/customer`);
    }
    catch (_a) {
        if (userManagementCallObsLogout) {
            if (hasCookieForSession()) {
                yield logout();
            }
        }
        const refreshToken = getRefreshToken();
        if (umtFECallKeycloakLogoutOnSessionTimeout && refreshToken) {
            yield keycloakLogout(refreshToken);
        }
        trackEvent(createLogOutSucceededEvent({ zone: platform }), true);
    }
});
//# sourceMappingURL=services.js.map